import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Warning = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill={fill}
      {...rest}
      width={Sizes[size]}
      height={Sizes[size]}
    >
      <path
        d="M9.6 0a9.6 9.6 0 1 0 9.6 9.6A9.611 9.611 0 0 0 9.6 0zm1.316 4l-.516 7.2H8.8L8.314 4zM9.6 16a1.6 1.6 0 1 1 1.6-1.6A1.6 1.6 0 0 1 9.6 16z"
        transform="translate(2 2)"
      />
    </svg>
  );
};

Warning.displayName = 'Warning';
